import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexTutors(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/tutors`, { params });
}

export function fetchInsightsDashboard(tutorId: number | string): Promise<ApiResponse> {
  return Axios.get(`v1/supervisors/tutors/${tutorId}/dashboard`);
}
